//ユーザーエージェントによるビューポートの動的な切り替え
// $(function(){
//   var ua = navigator.userAgent;
//   if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
//     $('head').prepend('<meta name="viewport" content="width=1024">');
//   }
// });

$(window).on("load scroll",function (){
  $(".effect").each(function(){ 
    var imgPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > imgPos - windowHeight + windowHeight/5){
      $(this).addClass("animated");
    }
  });
});

$(function(){
  $('a[href^="#"]').not("[data-lity]").not(".jdgm-write-rev-link").click(function(){
    var speed = 1000;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  
  var spBtn= $(".p-hd-menu");
  spBtn.on('click',function(){
    $(this).next("nav").addClass("on");
    $("header").addClass("on");
  });
  var spBtnClose= $(".p-hdNav__close,.p-hd-overlay");
  spBtnClose.on('click',function(){
    spBtnClose.parent("nav").removeClass("on");
    $("header").removeClass("on");
  });

  var prPopOpen= $(".pop_open");
  var prPopClose= $(".pop_close");
  var prPop= $(".product_pop");
  prPopOpen.on('click',function(){
    prPop.addClass("active");
  });
  prPopClose.on('click',function(){
    prPop.removeClass("active");
  });
  
  var idNews= $("#js-open-news");
  var num = $(this).find('.p-newsList__child').length;
  if(num <= 8){
    idNews.remove();
  }
  idNews.on('click',function(){
    idNews.prev().addClass("active");
    $(this).remove();
  });
  
  $(window).on("resize load",function(){
    var w = $(window).width();
    var x = 768;
    if (w <= x) {
      var acBtn= $(".ac-open");
      acBtn.off('click');
      acBtn.on('click',function(){
        $(this).next().slideToggle();
        $(this).toggleClass("active");
      });
    }
  });
  
  var faqBtn= $(".js-ac-open");
  faqBtn.on('click',function(){
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });

  var popBtn= $("#js-pop_opne");
  var popClose= $("#js-pop_close,#js-pop_overlay");
  popBtn.on('click',function(){
    $("#popup").addClass("active");
  });
  popClose.on('click',function(){
    $("#popup").removeClass("active");
  });

  var newsBtn= $("#news_more");
  newsBtn.on('click',function(){
    $(this).prev().addClass("active");
    $(this).css("display","none");
  });
	
  $(window).on('load scroll',function(){
    var top_level = $('.top_level');
    if(top_level.length){
      var thisOffset = top_level.offset().top + top_level.outerHeight();
      if( $(window).scrollTop() > 5){
          $("header").addClass("active");
      } else {
          $("header").removeClass("active");
      }
    }
  });



  $(window).on("load resize", function () {
    var w = $(window).width();
    var x = 768;
    var paddingAdjust = $(".js-padding-header"); // ヘッダー分のパディングを付与する要素　main
    var pankuzuAdjust = $(".js-top-header"); // ヘッダー分の高さを付与する要素　パンくず
    if (paddingAdjust.length) {
      var headerHeight = $(".l-header").height();
      paddingAdjust.css("padding-top",headerHeight);
    }
    if (pankuzuAdjust.length) {
      var headerHeight = $(".l-header").height();
      if(w > 768) { //PCのとき
        pankuzuAdjust.css("top","calc("+ headerHeight +"px + .44rem)");
      } else {     //SPのとき
        pankuzuAdjust.css("top","calc("+ headerHeight +"px + .49rem)");
      }
    }
  });
});
